import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute, ParamMap, Route, Router } from '@angular/router';
import { SimpleSearch } from 'src/app/core/models/simple-search.model';
import { Client } from '../models/client.model';
import { ClientService } from '../services/client.service';
import { UserService } from '../services/user.service';
import { dynamicSort } from 'src/app/shared/functions/sort';
import { DisplayErrorService } from 'src/app/shared/display-error/display-error.service';

@Component({
    selector: 'list-clients',
    templateUrl: './list-clients.component.html',
    standalone: false
})
export class ListClientsComponent implements OnInit {

    public clients: Client[];
    public isLoading: boolean;
    public isBusy: boolean; 
    private currentOrder: string = 'clientId';

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private errorNotification: DisplayErrorService,
        private clientService: ClientService) {
        this.clients = [];
        this.isLoading = true;
    }

    ngOnInit(): void {

        this.route.queryParamMap
            .subscribe(params => {
                this.loadClients();
            });

    }

    loadClients() {
        let search = new SimpleSearch();
        this.isLoading = true;

        this.clientService.listClients(search)
            .then(response => {
                console.log('## Clients ##', response);
                this.clients = response.clients;
                this.isLoading = false;
            }).catch(error => {
                console.warn(error);
            });
    }

    toggleEnable(client: Client) {

        if (client.isBusy)
            return;

        client.isBusy = true;

        if (client.enabled) {
            this.clientService.disableClient(client.clientId).then(x => {
                client.enabled = false;
                client.isBusy = false;
            });
        } else {
            this.clientService.enableClient(client.clientId).then(x => {
                client.enabled = true;
                client.isBusy = false;
            });
        }
    }
  
    createClient() {
        this.router.navigate(['/createClient']);
    }

    gotoClientSecrets(client: Client) {
        this.router.navigate(['clients', client.clientId, 'details']);
    }

    deleteClient(client: Client) {
        client.isBusy = true;
        this.clientService.deleteClient(client.clientId).then(
            () => client.isDeleted = true,
            (response) => {
                this.errorNotification.display(response);        
        }).finally(() => { client.isBusy = false; }            
        );
    }

    icon(client: Client): string {
        switch(client.clientType) {
            case 'siteInfoImport':
                return 'fas fa-download';
            case 'siteInfoExport':
                return 'fas fa-upload';
            case 'internal':
                return 'fas fa-building'
            default:
                return 'fas fa-question-circle'; 
        }
    }

    orderBy(property: string) {

        if (this.currentOrder != property) {
            this.currentOrder = property;
        } else {
            // flip sort order
            this.currentOrder = this.currentOrder[0] === '-' ?
                property : '-' + property;
        }

        this.clients = this.clients.sort(dynamicSort(this.currentOrder));
    }



}



